import React from 'react';
import product from 'data/can-store/product';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Rating from '@mui/material/Rating';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ModernProductViewer from 'containers/can-store/modernTemplate/ModernProductViewer';

// Todo: Back to Previous Page button.
// Todo: ProductViewer component

function ModernTemplateProduct(): JSX.Element {
	const [count, setCount] = React.useState<string>('1');

	const handleChange = (event: SelectChangeEvent) => {
		setCount(event.target.value as string);
	};

	return (
		<Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
			<Button
				startIcon={<ArrowBackIosIcon />}
				size="small"
				sx={{
					color: 'var(--csmd-cl-border-primary)',
					borderColor: 'var(--csmd-cl-border-primary)',
					textTransform: 'none',
					width: '80px',
				}}
			>
				Back
			</Button>
			<Stack direction="row" spacing={7}>
				<ModernProductViewer />
				<Stack direction="column" spacing={1}>
					<Typography variant="h5" gutterBottom sx={{ color: 'var(--csmd-cl-text-primary)' }}>
						{product.title}
					</Typography>
					<Stack direction="row" spacing={3}>
						<Stack direction="column" spacing={1}>
							<Typography
								sx={{
									fontWeight: 'bold',
									color: 'var(--csmd-cl-text-primary)',
									fontSize: '0.9rem',
								}}
							>
								Brand:
							</Typography>
							<Typography
								sx={{
									fontWeight: 'bold',
									color: 'var(--csmd-cl-text-primary)',
									fontSize: '0.9rem',
								}}
							>
								Category:
							</Typography>
							<Typography
								sx={{
									fontWeight: 'bold',
									color: 'var(--csmd-cl-text-primary)',
									fontSize: '0.9rem',
								}}
							>
								Rated:
							</Typography>
							<Typography
								sx={{
									fontWeight: 'bold',
									color: 'var(--csmd-cl-text-primary)',
									fontSize: '0.9rem',
								}}
							>
								Price:
							</Typography>
							<Typography
								sx={{
									fontWeight: 'bold',
									color: 'var(--csmd-cl-text-primary)',
									fontSize: '0.9rem',
								}}
							>
								Quantity:
							</Typography>
						</Stack>
						<Stack direction="column" spacing={1}>
							<Typography sx={{ color: 'var(--csmd-cl-text-primary)', fontSize: '0.9rem' }}>
								{product.brand}
							</Typography>
							<Typography sx={{ color: 'var(--csmd-cl-text-primary)', fontSize: '0.9rem' }}>
								{product.category}
							</Typography>
							<Box component="div">
								<Rating
									value={product.rating}
									size="small"
									readOnly
									sx={{ verticalAlign: 'middle' }}
								/>
								<Typography
									component="span"
									sx={{ color: 'var(--csmd-cl-text-primary)', fontSize: '0.9rem' }}
								>
									{' '}
									({product.rating})
								</Typography>
							</Box>
							<Typography
								sx={{
									color: 'var(--csmd-cl-primary-main)',
									fontWeight: 'bold',
									fontSize: '1rem',
								}}
							>
								$ {product.price}
							</Typography>
							<Box sx={{ width: '70px' }}>
								<FormControl fullWidth>
									<Select
										value={count}
										onChange={handleChange}
										sx={{ height: '20px', fontSize: '0.9rem' }}
									>
										<MenuItem value={1}>1</MenuItem>
										<MenuItem value={2}>2</MenuItem>
										<MenuItem value={3}>3</MenuItem>
									</Select>
								</FormControl>
							</Box>
						</Stack>
					</Stack>
					<Typography
						sx={{
							fontWeight: 'bold',
							color: 'var(--csmd-cl-text-primary)',
							fontSize: '0.9rem',
						}}
					>
						Description:
					</Typography>
					<Typography sx={{ color: 'var(--csmd-cl-text-primary)', fontSize: '0.9rem' }}>
						{product.description}
					</Typography>
				</Stack>
			</Stack>
		</Box>
	);
}

export default ModernTemplateProduct;
